<template>
  <v-dialog v-model="dialog" max-width="700px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', cest)">
      <v-card v-if="cest" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} CEST </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="cest.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="cest.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataInicioFormatada"
                        v-mask="['##/##/####']"
                        label="Inicio"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataInicio = parseDate(dataInicioFormatada)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dataInicio" @input="menuDataInicio = false" />
                  </v-menu>
                </v-col>
                <v-col>
                  <v-menu
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFimFormatada"
                        v-mask="['##/##/####']"
                        label="Fim"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataFim = parseDate(dataFimFormatada)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dataFim" @input="menuDataFim = false" />
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="cest.segmento.id"
                    :items="itens.segmento"
                    :rules="[obrigatorio]"
                    label="Segmento"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="cest.ncm.id"
                    :items="itens.ncm"
                    :rules="[obrigatorio]"
                    label="NCM"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(cest)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import CEST from '../../models/cest'
import CESTService from '../../services/cest/cest'
import { obrigatorio } from '../../shareds/regrasForm'
import { formatDate, parseDate } from '@/shareds/formatacoes'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },

  props: ['showDialog', 'cestParam', 'operacao', 'itens'],

  data: () => ({
    dialog: false,
    cest: new CEST(),
    obrigatorio: obrigatorio,
    formatDate: formatDate,
    parseDate: parseDate,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false,
    dataInicio: '',
    dataFim: '',
    dataInicioFormatada: '',
    dataFimFormatada: ''
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    cestParam() {
      return this.cestParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },
    dataInicio() {
      if (this.dataInicio !== undefined) this.dataInicioFormatada = this.formatDate(this.dataInicio)
    },
    dataFim() {
      if (this.dataFim !== undefined) this.dataFimFormatada = this.formatDate(this.dataFim)
    }
  },
  methods: {
    initialize() {
      this.dataInicio = null
      this.dataFim = null
      this.dataInicioFormatada = null
      this.dataFimFormatada = null
      this.cest = new CEST()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.cest = this.cestParam
      this.dataInicio = this.cest.dataInicio
      this.dataFim = this.cest.dataFim
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim
        }

        const cestSalva =
          this.operacao === 'adicionar'
            ? await CESTService.create({ ...data })
            : await CESTService.update(data.id, data)

        this.$emit('confirmado', cestSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
